// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"27748072","239":"974a54e3","455":"a0505732","581":"21e96f4c","906":"883685e4","977":"2b56c2b8","992":"27430dd6"}[chunkId] + ".chunk.js";
};